import React, { useState, useCallback } from 'react';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { toast } from 'react-toastify';
import { schema } from './validationSchema';
import SecaoDadosAtivo from './components/SecaoDadosAtivo';
import SecaoDadosCompra from './components/SecaoDadosCompra';
import SecaoParcelamento from './components/SecaoParcelamento';
import ModalNovoAtivo from './components/ModalNovoAtivo';
import { lancarCompraImobilizado } from '~/Services/Service';
import { extrairMensagemErro } from '~/Utils/Helpers';

const initialValues = {
  codigoGrupoEmpresa: null,
  codigoFornecedor: null,
  codigoContaImobilizado: null,
  codigoMoeda: null,
  codigoDepartamento: null,
  observacao1: '',
  observacao2: '',
  observacao3: '',
  observacao4: '',
  itens: [],
  gerarAgendamento: true,
  numeroParcelas: null,
  primeiroVencimento: null,
  diaDemaisVencimentos: null,
};

const mapValuesToPayload = values => ({
  codigo_grupo_empresa: values.codigoGrupoEmpresa,
  codigo_fornecedor: values.codigoFornecedor,
  codigo_conta_imobilizado: values.codigoContaImobilizado,
  codigo_moeda: values.codigoMoeda,
  codigo_departamento: values.codigoDepartamento != null ? values.codigoDepartamento : null,
  observacao_1: values.observacao1 || '',
  observacao_2: values.observacao2 || '',
  observacao_3: values.observacao3 || '',
  observacao_4: values.observacao4 || '',
  itens: values.itens.map(item => ({
    codigo_ativo: item.codigoAtivo,
    quantidade: item.quantidade,
    valor_unitario: item.valorUnitario,
  })),
  gerar_agendamento: values.gerarAgendamento,
  numero_parcelas: values.gerarAgendamento ? values.numeroParcelas : null,
  primeiro_vencimento: values.gerarAgendamento ? values.primeiroVencimento : null,
  dia_demais_vencimentos: values.gerarAgendamento ? values.diaDemaisVencimentos : null,
});

const LancamentoCompraImobilizado = () => {
  const [showModalNovoAtivo, setShowModalNovoAtivo] = useState(false);
  const [ativoRecemCriado, setAtivoRecemCriado] = useState(null);

  const handleNovoAtivoSalvo = useCallback(ativo => {
    setAtivoRecemCriado(ativo);
    setShowModalNovoAtivo(false);
  }, []);

  return (
    <Container fluid className="mt-3">
      <Card className="shadow-sm mb-3">
        <Card.Header style={{ background: '#0747a6', color: '#fff', fontWeight: 700, fontSize: 15 }}>
          Cadastro de Imobilizado — Lançamento de Compra
        </Card.Header>
        <Card.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={async (values, { resetForm }) => {
              try {
                const payload = mapValuesToPayload(values);
                const res = await lancarCompraImobilizado(payload);
                const mensagem =
                  res && res.mensagem ? res.mensagem : 'Compra lançada com sucesso.';
                toast.success(mensagem);
                resetForm();
                setAtivoRecemCriado(null);
              } catch (err) {
                toast.error(extrairMensagemErro(err));
              }
            }}
          >
            {({ values, setFieldValue, isSubmitting, errors, isValid, submitCount }) => (
              <Form noValidate>
                <SecaoDadosAtivo
                  itens={values.itens}
                  onChange={itens => setFieldValue('itens', itens)}
                  onAbrirModalNovoAtivo={() => setShowModalNovoAtivo(true)}
                  ativoRecemCriado={ativoRecemCriado}
                />
                {submitCount > 0 && errors.itens && typeof errors.itens === 'string' && (
                  <Alert variant="warning" className="py-1 px-2 mb-2" style={{ fontSize: 13 }}>
                    {errors.itens}
                  </Alert>
                )}

                <SecaoDadosCompra />

                <SecaoParcelamento />

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <small className="text-muted">* Campos obrigatórios</small>
                  <Button
                    type="submit"
                    variant="success"
                    disabled={isSubmitting}
                    style={{ minWidth: 140 }}
                  >
                    {isSubmitting ? (
                      <>
                        <Spinner animation="border" size="sm" className="mr-1" />
                        Lançando...
                      </>
                    ) : (
                      'Lançar Compra'
                    )}
                  </Button>
                </div>

                {submitCount > 0 && !isValid && (
                  <Alert variant="danger" className="mt-2 py-1 px-2" style={{ fontSize: 13 }}>
                    Corrija os erros acima antes de lançar.
                  </Alert>
                )}
              </Form>
            )}
          </Formik>
        </Card.Body>
      </Card>

      <ModalNovoAtivo
        show={showModalNovoAtivo}
        onFechar={() => setShowModalNovoAtivo(false)}
        onSalvar={handleNovoAtivoSalvo}
      />
    </Container>
  );
};

export default LancamentoCompraImobilizado;
